import { Box } from '@mui/material';

import { routesApp } from 'shared/config';
import { NavTabs } from 'shared/ui';

const NAV_TABS = [
  { name: 'Vaccines', path: routesApp.peoplesVaccines },
  { name: 'Diseases', path: routesApp.peoplesDiseases },
  { name: 'Countries', path: routesApp.peoplesCountries },
  { name: 'Post-vaccination reactions', path: routesApp.peoplesReactions },
];

export const Main = () => {
  return (
    <Box display="flex" flexDirection="column" flex={1} px={3}>
      <NavTabs tabs={NAV_TABS} />
    </Box>
  );
};
